import * as Yup from 'yup';
import dayjs from 'dayjs';
import { ZIPCODE_ERROR_VALIDATION_MSG, ZIPCODE_REGEX } from '../constants/address';

export const guestOrderValidationSchema = Yup.object().shape({
  name: Yup.string().required('Name is required'),
  email: Yup.string().email('Invalid email').required('Email is required'),
});

export const orderAddressCheckoutSchema = Yup.object({
  email: Yup.string().email('Invalid email address').required('Email is required'),
  address1: Yup.string().required('Address is required').min(3, 'Address must be at least 3 characters'),
  city: Yup.string().required('City is required').min(2, 'City must be at least 2 characters'),
  state: Yup.string()
    .required('State is required')
    .matches(/^[A-Z]{2}$/, 'State must be a 2-letter code'),
  zipcode: Yup.string().matches(ZIPCODE_REGEX, ZIPCODE_ERROR_VALIDATION_MSG).required('Required'),
});

export const OrderCheckoutSubjectsSchema = Yup.object().shape({
  subjects: Yup.array().of(
    Yup.object().shape({
      name: Yup.string()
        .required('Name is required')
        .test('has-both-first-and-last-name', 'Please enter both first and last name', function (value) {
          if (!value) return false;
          const fullNamePieces = value.trim().split(/\s+/);
          return fullNamePieces.length >= 2;
        }),
      isAnAdult: Yup.boolean().oneOf([true], 'You must agree to the age requirements'),
      dob: Yup.date()
        .nullable()
        .required('Date of birth is required')
        .max(dayjs().subtract(18, 'years'), 'You must be at least 18 years old'),
      phoneNumber: Yup.string().required('Phone number is required').min(10, 'Phone number must be at least 10 digits'),
    }),
  ),
});
